import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { Route as rootRoute } from "./__root";

// Portal de padres de Kidstenia — vivía en "/kidstenia" y se movió acá para dejar esa URL
// libre para una futura página pública que atraiga alumnos nuevos al programa (pedido
// explícito). Los links viejos siguen funcionando gracias al redirect en kidstenia.tsx. Ver
// getKidstiniaAlumnoProgreso en functions/index.js para el porqué del acceso por token en vez
// de login.
export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: "/padres",
  // noindex: el token va en la URL — no debe quedar cacheado ni indexado por buscadores.
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: lazyRouteComponent(() => import("./kidstenia-page"), "KidsteniaPage"),
});
